<script setup lang="ts">
import { computed, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
    required: true
  },
  loading: {
    type: String,
    default: 'none',
    required: false
  },
  hasMore: {
    type: Boolean,
    default: false,
    required: false
  },
  up: {
    type: Boolean,
    default: false,
    required: false
  }
})

const isLoading = computed(() => props.loading)
const isHasMore = computed(() => props.hasMore)

const stateStr = computed(() => {
  switch (isLoading.value) {
    case 'loading':
      return t('alt.loading')
    case 'none':
      return isHasMore.value ? t('alt.scroll_download_to_load') : t('alt.no_more')
    case 'failed':
      return t('alt.failed')
    default:
      return props.up ? t('alt.scroll_up_to_load') : t('alt.scroll_download_to_load')
  }
})
</script>
<template>
  <div min-h-24 w-full flex-r-center cursor-pointer mb-15>
    <!-- <p w-full text-center text-third>{{ $t('app.name') }}</p> -->
    <div v-if="modelValue" flex-r-center>
      <div v-if="isLoading === 'loading'" i-eva:loader-outline animate-spin text-xl text-third></div>
      <p :class="isLoading !== 'failed' ? 'text-third' : 'text-danger'" ml-3 text-sm>
        {{ stateStr }}
      </p>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
